module.exports = __webpack_public_path__ + "static/img/defaultTeam.1d25f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/defaultTeam.png
// module id = 605
// module chunks = 2